import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { StateService } from "../../state/state.service";
import { Kasko } from "../../core/model/kasko";
import { KaskoDaoService } from "../../core/dao-service/kasko-dao.service";
import * as printJS from "print-js";
import { ModalClientTypeComponent } from "../../kasko-new/modal-client-type/modal-client-type.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-kasko-card",
  templateUrl: "./kasko-card.component.html",
  styleUrls: ["./kasko-card.component.scss"],
})
export class KaskoCardComponent implements OnInit, OnDestroy {
  @Input() kasko: Kasko;
  @Input() type: string = "kasko-view";

  isProcessing$: Subscription = null;
  kaskoId: string;
  currentState: any;
  showSpinner = true;
  userType: string;

  constructor(
    private router: Router,
    private kaskoService: KaskoDaoService,
    private state: StateService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.kaskoId = this.state.snapshot.kasko.kaskoId;
    this.userType = this.state.snapshot.auth.userPath;

    console.log(this.kasko);

    if (!this.kasko.imgReceiptUrl) {
      this.showSpinner = false;
    }
  }

  ngOnDestroy(): void {
    this.isProcessing$ ? this.isProcessing$.unsubscribe() : null;
  }

  checkUserType() {
    if (this.userType === "lab") {
      return false;
    } else {
      return true;
    }
  }
  imageLoaded() {
    this.showSpinner = false;
  }

  handleServerError(error) {
    console.log(error);
  }

  acceptCostAndGoToInfoView() {
    if (this.isProcessing$) {
      return;
    }

    this.isProcessing$ = this.kaskoService
      .put(this.kaskoId, { state: "accettato" }, "state")
      .subscribe(
        () =>
          this.modalService.open(ModalClientTypeComponent, {
            size: "lg",
            container: "nb-layout-column",
          }),
        null,
        () => (this.isProcessing$ = null)
      );
  }

  declineCostGoToOrderList() {
    if (this.isProcessing$) {
      return;
    }

    this.isProcessing$ = this.kaskoService
      .put(this.kaskoId, { state: "accettato" }, "state")
      .subscribe(
        () => this.router.navigate(["shop", "kasko-new", "kasko-init"]),
        null,
        () => (this.isProcessing$ = null)
      );
  }

  getPayload() {
    if (this.currentState != "in lavorazione") {
      return { state: this.currentState.next };
    }

    return { state: this.currentState.next.toShop };
  }

  printPage() {
    printJS({
      printable: "print-section",
      type: "html",
      header:
        '<div><div style="float:left; width:32%;margin-bottom:110px;margin-top:40px;margin-left:20px;"><img src="../../../assets/images/geniuslogonuovo01.svg" alt="GeniusRepair"></div><div style="float:left; width:32%;margin-bottom:110px;margin-top:40px;"><h1>Preventivo</h1></div><div style="float:right; width:33%;margin-bottom:110px;margin-top:40px;font-size:1.5em;"><p>GENIUS S.R.L. <br><br>(P. IVA 12972690155)<br><br> Via Soperga, 36 - 20127 MILANO.</p></div></div>',
      documentTitle: "Preventivo",
      maxWidth: 2500,
      scanStyles: true,
      targetStyles: ["*"],
      style: "@page { size: A3 portrait }",
      onError: (error) => {
        console.log("error print");
        console.log(error);
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/kasko-card/kasko-card.component.ts